import {computed, inject, Injectable, signal} from '@angular/core';
import {Circular, Evento} from '@kilobytelab/types';
import {LocalStorageService} from './storage.service';
import {ApiAppService} from '@kilobytelab/domain';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  private localstorage = inject(LocalStorageService);
  private apiApp = inject(ApiAppService);
  private appService = inject(AppService);

  AGENDAS = signal<{idAlumno: number, eventos: (Evento & Circular)[]}[]>([]);

  agendaDisponible = computed<boolean>(() => {
    const alumnoActivo = this.appService.ALUMNO();
    const status = this.appService.fechas();
    const agendas = this.AGENDAS();
    if (!alumnoActivo || !agendas?.length) return false;
    const agendaAlumno: Evento[] = agendas.find(e => e.idAlumno === alumnoActivo.id)?.eventos;
    if (!agendaAlumno?.length) return false;
    const fechaStatus = status?.agendas;
    if (!fechaStatus) return true;
    const fechaUltimoEvento = String(agendaAlumno[0].fecha);
    const fechaVisto = String(fechaStatus);
    return fechaUltimoEvento > fechaVisto
  });

  async marcarAgendaComoVista() {
    const ahora = new Date().toISOString();
    this.appService.fechas.update(fechas => ({...fechas, agendas: ahora}));
    await this.localstorage.setFechas(this.appService.fechas())
  }

  async checkAgenda() {
    const alumnos = this.appService.PADRE();
    if (!alumnos?.length) {
      this.AGENDAS.set([]);
      await this.localstorage.setAgenda([]);
      return
    }
    try {
      const peticiones = alumnos.map(async (alumno) => {
        const eventos: (Evento & Circular)[] = await this.apiApp.getEventos(alumno.id);
        this.updateAgenda(alumno.id, eventos);
      });
      await Promise.all(peticiones);
      await this.localstorage.setAgenda(this.AGENDAS())
    } catch (err) {
      const guardada: {idAlumno: number, eventos: (Evento & Circular)[]}[] = await this.localstorage.getAgenda();
      if (!guardada) {
        throw new Error('Error recuperando las agendas')
      }
      this.AGENDAS.set(guardada)
    }
  }

  private updateAgenda(id: number, nuevos: (Evento & Circular)[]) {
    this.AGENDAS.update(agendas => {
      const index = agendas.findIndex(a => a.idAlumno === id);
      if (index === -1) return [...agendas, {idAlumno: id, eventos: nuevos}];
      const agendasClonadas = [...agendas];
      const agendaActual = agendasClonadas[index];
      if (!agendaActual.eventos?.length) {
        agendasClonadas[index] = {...agendaActual, eventos: nuevos};
        return agendasClonadas
      }
      const eventosFusionados = nuevos.map(e => {
        const ev = agendaActual.eventos.find(evento => evento.fecha === e.fecha);
        return ev ? { ...ev, ...e } : e;
      });
      agendasClonadas[index] = {...agendaActual, eventos: eventosFusionados};
      return agendasClonadas
    })
  }

}